/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Live_CtaInputs */

const en_us2_quick_workout_live_cta = /** @type {(inputs: Quick_Workout_Live_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to the workout`)
};

const pt_br2_quick_workout_live_cta = /** @type {(inputs: Quick_Workout_Live_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o treino`)
};

const es_419_quick_workout_live_cta = /** @type {(inputs: Quick_Workout_Live_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al entrenamiento`)
};

const pt_pt2_quick_workout_live_cta = /** @type {(inputs: Quick_Workout_Live_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o treino`)
};

const fr_fr2_quick_workout_live_cta = /** @type {(inputs: Quick_Workout_Live_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller à la séance`)
};

const de_de2_quick_workout_live_cta = /** @type {(inputs: Quick_Workout_Live_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Training`)
};

const it_it2_quick_workout_live_cta = /** @type {(inputs: Quick_Workout_Live_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai all'allenamento`)
};

/**
* | output |
* | --- |
* | "Go to the workout" |
*
* @param {Quick_Workout_Live_CtaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_live_cta = /** @type {((inputs?: Quick_Workout_Live_CtaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Live_CtaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_live_cta(inputs)
	if (locale === "es-419") return es_419_quick_workout_live_cta(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_live_cta(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_live_cta(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_live_cta(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_live_cta(inputs)
	return en_us2_quick_workout_live_cta(inputs)
});
export { quick_workout_live_cta as "quick-workout.live_cta" }